/**
 * Every user-facing string in the admin panel, in Uzbek (Latin).
 *
 * Same rule as the Mini App: no component may hold a display literal. The operators are
 * Uzbek-speaking staff, so the admin panel is localised too — only code, comments and tests
 * are English.
 */
export const strings = {
  app: {
    title: 'Qaytim Admin',
    loading: 'Yuklanmoqda…',
    error: 'Xatolik yuz berdi',
    retry: 'Qayta urinish',
    empty: "Ma'lumot yo'q",
  },
  shell: {
    // Yon paneldagi guruh sarlavhalari — bo'limlar soni oltitaga yetgach ro'yxat ikkiga bo'lindi.
    groupOperations: 'Kundalik ish',
    groupSystem: 'Tizim',
    subtitle: 'Operator konsoli',
    openMenu: 'Menyuni ochish',
    closeMenu: 'Menyuni yopish',
    themeToLight: "Yorug' mavzuga o'tish",
    themeToDark: "Qorong'i mavzuga o'tish",
  },
  common: {
    refresh: 'Yangilash',
    refreshing: 'Yangilanmoqda…',
    previous: 'Orqaga',
    next: 'Keyingi',
    reset: 'Tozalash',
    close: 'Yopish',
    cancel: 'Bekor qilish',
    updated: 'Yangilandi',
    loadFailed: "Ma'lumotni yuklab bo'lmadi",
    back: 'Orqaga qaytish',
    open: 'Ochish',
    notFound: 'Bunday yozuv topilmadi.',
    copy: 'Nusxalash',
    copied: 'Nusxalandi',
  },
  /**
   * Forma validatsiyasining umumiy xabarlari.
   *
   * Ular zod ning O'Z xabarlari o'rniga qo'yiladi (`lib/zod-messages.ts`). Sabab: tekshiruv
   * qoidalari `@qaytim/shared` dagi sxemalarda yashaydi va u yerda ingliz tilidagi standart
   * matnlar bor — ular to'g'ridan-to'g'ri operatorning ekraniga chiqib ketardi. Har bir formada
   * qo'lda xabar yozish esa bir xil qoidani turli jumlalar bilan tushuntirishga olib kelardi.
   *
   * `{min}`/`{max}` — sxemadan keladigan qiymatlar, ya'ni raqamlar bu yerda yozilmaydi.
   */
  validation: {
    required: 'Bu maydonni to‘ldiring',
    tooShort: 'Kamida {min} ta belgi kiriting',
    tooLong: 'Ko‘pi bilan {max} ta belgi',
    numberRequired: 'Raqam kiriting',
    tooSmall: 'Eng kichik qiymat: {min}',
    positiveRequired: 'Noldan katta son kiriting',
    tooBig: 'Eng katta qiymat: {max}',
    integerRequired: 'Butun son kiriting',
    invalid: 'Qiymat noto‘g‘ri',
  },
  /**
   * Foydalanuvchi ustidagi qo'lda amallar.
   *
   * Har bir tugma matni AMALNI aytadi, natijani emas ("Bloklash", "Ballni tuzatish"), chunki
   * ular tasdiq oynasini ochadi — bosish o'zi hech narsani o'zgartirmaydi.
   */
  userActions: {
    heading: 'Amallar',
    subtitle: 'Har bir amal audit jurnaliga sabab bilan yoziladi.',
    reason: 'Sabab',
    reasonHint: 'Audit jurnaliga yoziladi va uni boshqa xodim o‘qiydi.',
    block: 'Bloklash',
    blockTitle: 'Foydalanuvchini bloklash',
    blockHint: 'Bloklangan odam ilovaga kira olmaydi va unga xabar yuborilmaydi.',
    unblock: 'Blokdan chiqarish',
    unblockTitle: 'Blokdan chiqarish',
    blocked: 'Bloklandi',
    unblocked: 'Blokdan chiqarildi',
    points: 'Ballni tuzatish',
    pointsTitle: 'Ballni qo‘lda tuzatish',
    pointsAmount: 'Miqdor',
    pointsAmountHint: 'Musbat — qo‘shish, manfiy — yechish. Nol bo‘lmaydi.',
    pointsDone: 'Balans yangilandi',
    ticket: 'Bilet berish',
    ticketTitle: 'Kompensatsiya bileti',
    ticketHint:
      'Bu bilet hech qaysi kunlik chegarani band qilmaydi — u xato uchun tovon, foydalanuvchining o‘z imkoniyati hisobiga tushmaydi.',
    ticketDate: 'Qaysi kunning tortishuviga',
    ticketDone: 'Bilet berildi',
    submit: 'Tasdiqlash',
  },
  /**
   * Rasm bo'yicha moderator qarori.
   */
  photoModeration: {
    heading: 'Qaror',
    subtitle: 'Rad etish ballni ham, biletni ham qaytaradi.',
    approve: 'Tasdiqlash',
    approveTitle: 'Rasmni tasdiqlash',
    approveHint: 'Ko‘rik yopiladi. Qo‘shimcha mukofot berilmaydi.',
    reject: 'Rad etish',
    rejectTitle: 'Rasmni rad etish',
    rejectHint: 'Berilgan ball qaytariladi, bilet esa bekor qilinadi.',
    approved: 'Rasm tasdiqlandi',
    rejected: 'Rasm rad etildi',
    onlyInReview: 'Qaror faqat ko‘rikdagi skan uchun mumkin.',
  },
  /**
   * Detail sahifalar.
   *
   * Uch sahifa umumiy lug'atdan foydalanadi: ular bir xil savolga javob beradi ("bu qator
   * nima va u bilan nima bo'lgan"), va har biriga alohida "Egasi" so'zini yozish uchtasini
   * vaqt o'tishi bilan bir-biridan ajratib yuborardi.
   */
  detail: {
    ownerHeading: 'Egasi',
    ownerBalance: 'Balans',
    ownerBlocked: 'Bloklangan',
    openUser: 'Foydalanuvchi kartochkasi',
    linkedTicket: 'Bog‘langan bilet',
    ledgerHeading: 'Ball harakati',
    auditHeading: 'Amallar tarixi',
    auditEmpty: 'Bu yozuv ustida hali hech qanday amal bajarilmagan.',
    auditAdmin: 'Kim',
    auditAction: 'Amal',
    auditWhen: 'Qachon',
    auditDetails: 'Tafsilot',
    receiptTitle: 'Chek',
    receiptSubtitle: 'Chek qatorlari, soliq havolasi va ball harakati.',
    receiptItems: 'Chek qatorlari',
    receiptQr: 'QR va havola',
    receiptOpenSource: 'Soliq sahifasini ochish',
    receiptFiscalKey: 'Fiskal kalit',
    receiptMerchant: 'Sotuvchi',
    receiptIssuedAt: 'Chek sanasi',
    receiptWeek: 'Hafta',
    receiptAttempts: 'Urinishlar',
    receiptFetchedAt: 'Tafsilot olingan',
    receiptRetryAt: 'Keyingi urinish',
    receiptRevokedReason: 'Bekor qilish sababi',
    columnName: 'Nomi',
    columnPrice: 'Narxi',
    columnQuantity: 'Miqdori',
    photoTitle: 'Rasm skani',
    photoSubtitle: 'Rasmning o‘zi, tanilgan qatorlar va ball harakati.',
    photoImage: 'Rasm',
    photoImageMissing: 'Rasmni ochib bo‘lmadi.',
    photoOpenFull: 'To‘liq o‘lchamda ochish',
    photoItems: 'Tanilgan qatorlar',
    photoProvider: 'Vision xizmati',
    photoSize: 'Hajmi',
    photoConfirmedAt: 'Tasdiqlangan',
    photoSubject: 'Turi',
    columnOriginalName: 'AI aytgan nom',
    columnConfidence: 'Ishonch',
    columnConfirmed: 'Tasdiqlangan',
    columnEdited: 'Tahrirlangan',
    yes: 'Ha',
    no: 'Yo‘q',
    ticketTitle: 'Bilet',
    ticketSubtitle: 'Bilet, uni keltirgan skan va u ustida bajarilgan amallar.',
    ticketSource: 'Manba',
    ticketAcquired: 'Olingan sana',
    ticketMonth: 'Oy',
    ticketVerifiedAt: 'Tasdiqlangan',
    ticketWonDraw: 'Yutgan efir',
    sourceReceipt: 'Chek',
    sourcePhoto: 'Rasm skani',
  },
  /**
   * Sahifalash paneli.
   *
   * `rangeOf` ataylab uch o'rinli: "1–20 / 340". Faqat sahifa raqamini ko'rsatish operatorga
   * ish hajmini aytmaydi, faqat jami sanoq esa u qayerda turganini aytmaydi.
   */
  pager: {
    rangeOf: '{from}–{to} / {total}',
    pageOf: '{page}-sahifa, jami {pageCount} ta',
    empty: 'Qator yo‘q',
    perPage: 'Sahifada',
    first: 'Birinchi sahifa',
    last: 'Oxirgi sahifa',
    previous: 'Oldingi sahifa',
    next: 'Keyingi sahifa',
    total: 'Jami',
  },
  // Kalendar paneli. Oy va hafta nomlari bu yerda EMAS — ular `lib/calendar.ts` da, panelning
  // matematikasi bilan yonma-yon, chunki ustunlar tartibi (dushanbadan) nomlarga bog'liq.
  datePicker: {
    placeholder: 'Sanani tanlang',
    nothingSelected: 'Tanlanmagan',
    today: 'Bugun',
    time: 'Soat',
    clear: 'tozalash',
    previousMonth: 'Oldingi oy',
    nextMonth: 'Keyingi oy',
    previousYear: 'Oldingi yil',
    nextYear: 'Keyingi yil',
  },
  login: {
    title: 'Admin panelga kirish',
    email: 'Email',
    password: 'Parol',
    submit: 'Kirish',
    submitting: 'Kirilmoqda…',
    invalidCredentials: "Email yoki parol noto'g'ri",
    emailRequired: 'Emailni kiriting',
    passwordRequired: 'Parolni kiriting',
    networkError: "Serverga ulanib bo'lmadi",
    // `{time}` — serverdan kelgan `retryAt`, Toshkent vaqtida. Chegara raqami `constants.ts` da.
    rateLimited: 'Juda ko‘p urinish. {time} dan keyin qayta urinib ko‘ring.',
  },
  nav: {
    dashboard: 'Boshqaruv paneli',
    draws: 'Tortishuvlar',
    moderation: 'Moderatsiya',
    dlq: 'Xato navbat (DLQ)',
    users: 'Foydalanuvchilar',
    exportData: 'Data eksport',
    accounts: 'Admin hisoblari',
    rewards: 'Ball-katalog',
    redemptions: 'Sovg‘a buyurtmalari',
    banners: 'Bannerlar',
    notificationTemplates: 'Bot xabarlari',
    notifications: 'Xabarlar navbati',
    logout: 'Chiqish',
  },
  /**
   * Boshqaruv paneli.
   *
   * Sarlavhalar RAQAMSIZ: sonlar javobdan keladi va ular ekranga faqat komponent orqali
   * tushadi (`strings.spec.ts` shu qoidani ushlab turadi).
   */
  dashboard: {
    title: 'Boshqaruv paneli',
    subtitle: 'Tizimning hozirgi hajmi, kutib turgan ish va oxirgi oy dinamikasi.',
    generatedAt: 'Hisoblangan vaqt',
    // Kutib turgan ish — birinchi blok: qolgani o'tmish haqida, bu esa hozir haqida.
    queuesHeading: 'Kutib turgan ish',
    queuesSubtitle: 'Bu raqamlar nolga tushishi kerak — qolganlari shunchaki o‘sadi.',
    queueFraud: 'Tekshiruvdagi biletlar',
    queuePhotos: 'Ko‘rikdagi rasmlar',
    queueReceipts: 'Kutayotgan cheklar',
    queueNotifications: 'Yetmagan xabarlar',
    peopleHeading: 'Odamlar va ballar',
    contentHeading: 'Skanlar',
    statUsers: 'Foydalanuvchilar',
    statBlocked: 'bloklangan',
    statTickets: 'Biletlar',
    statReceipts: 'Cheklar',
    statPhotos: 'Mahsulot rasmlari',
    statMeals: 'Ovqat rasmlari',
    statPointsIssued: 'Berilgan ballar',
    statPointsReversed: 'Qaytarilgan ballar',
    statPointsBalance: 'Qo‘llardagi balans',
    statDraws: 'Efirlar',
    today: 'bugun',
    week: 'shu haftada',
    trendHeading: 'Oxirgi oy',
    trendSubtitle: 'Kunlik hisob, Toshkent vaqti bo‘yicha.',
    trendScans: 'Skanlar',
    trendGrowth: 'O‘sish',
    seriesUsers: 'Foydalanuvchilar',
    seriesReceipts: 'Cheklar',
    seriesPhotos: 'Mahsulot rasmlari',
    seriesMeals: 'Ovqat rasmlari',
    seriesTickets: 'Biletlar',
    statusHeading: 'Holatlar kesimi',
    statusReceipts: 'Cheklar holati',
    statusTickets: 'Biletlar holati',
    statusPhotos: 'Rasmlar holati',
    statusMeals: 'Ovqatlar holati',
    systemHealthHeading: 'Tizim va servislar holati',
    healthDatabase: 'Ma‘lumotlar bazasi (PostgreSQL)',
    healthRedis: 'Kesh va xabarlar (Redis)',
    healthStorage: 'Fayllar ombori (MinIO)',
    healthScraper: 'Soliq OFD skraperi',
    healthOperational: 'Ishchi holatda',
    healthDegraded: 'Cheklangan rejimda',
    healthOnline: 'Online',
  },
  draws: {
    title: 'Tortishuvlar boshqaruvi',
    subtitle: 'Efirlarni jadvalga qo‘yish, o‘tkazish va konsolga o‘tish.',
    statTotal: 'Jami efir',
    statScheduled: 'Rejalashtirilgan',
    statCompleted: 'O‘tkazilgan',
    statPostponed: 'Qoldirilgan',
    videoHint: 'Ixtiyoriy. Bo‘sh qoldirilsa, havola o‘zgarmaydi.',
    openVideo: 'Video',
    reminderQueued: 'Eslatma navbatga qo‘yilgan',
    formInvalid: 'Efir vaqti to‘liq kiritilmagan — sana va soatni tekshiring.',
    periodRequired: 'Davrni tanlang',
    scheduleHeading: 'Efirni jadvalga qo‘yish',
    // `{minutes}` — `DRAW_REMINDER_LEAD_MINUTES` dan. Raqamlar faqat `constants.ts` da yashaydi.
    scheduleHint:
      'Jadvalga qo‘yilgan efirdan {minutes} daqiqa oldin foydalanuvchilarga eslatma yuboriladi.',
    type: 'Turi',
    typeDaily: 'Kunlik',
    typeWeekly: 'Haftalik',
    typeMonthly: 'Oylik',
    drawDate: 'Tortishuv sanasi',
    /** Haftalik efirda sana — o'sha haftaning dushanbasi, efir kuni emas. */
    weekKey: 'Hafta (dushanba sanasi)',
    /** Dushanbadan boshqa kun tanlanganda. Shartnoma ham rad etadi, ammo inglizcha matn bilan. */
    weekMustBeMonday: 'Hafta dushanba sanasi bilan belgilanadi',
    monthKey: 'Oy (YYYY-MM)',
    scheduledAt: 'Efir vaqti (Toshkent)',
    prizeLabel: 'Sovrin',
    videoEmbedUrl: 'Video havolasi (YouTube yoki t.me)',
    save: 'Saqlash',
    saving: 'Saqlanmoqda…',
    saved: 'Jadval yangilandi',
    listHeading: 'Jadval va tarix',
    columnPeriod: 'Davr',
    columnStatus: 'Holat',
    columnPrize: 'Sovrin',
    columnScheduledAt: 'Efir vaqti',
    columnTickets: 'Biletlar',
    columnWinner: 'G‘olib',
    winnerCount: 'G‘oliblar soni',
    winnerCountHint: 'Nechta g‘olib chiqadi. Har biri efirda alohida e‘lon qilinadi.',
    prizes: 'Har bir g‘olibning sovrini',
    prizesHint:
      'Bo‘sh qoldirilsa, hamma g‘olib yuqoridagi umumiy sovrinni oladi. To‘ldirilsa — har biri o‘zinikini. O‘rin tartibi yo‘q.',
    prizeAt: '{n}-sovrin',
    prizesIncomplete: 'Sovrinlar to‘liq to‘ldirilishi kerak — yoki hammasi bo‘sh qolsin.',
    winnerPrizeColumn: 'Sovrin',
    winnersMore: 'yana {count} ta',
    columnActions: 'Amallar',
    statusScheduled: 'Rejalashtirilgan',
    statusCompleted: 'O‘tkazilgan',
    statusPostponed: 'Qoldirilgan',
    run: 'Tortishuvni o‘tkazish',
    running: 'O‘tkazilmoqda…',
    postpone: 'Qoldirish',
    postponeReason: 'Qoldirish sababi',
    console: 'Efir konsoli',
    /*
      Efirni ekrandan olib qo'yish — QOLDIRISH EMAS. Ikkalasi yonma-yon turgani uchun matn ham
      farqni aytadi: qoldirish o'yin bo'lmaganini bildiradi, bu esa faqat mini appdagi efir
      ekranini yopadi.
    */
    liveOn: 'Efirni ko‘rsatish',
    liveOff: 'Efirni yashirish',
    liveHiddenBadge: 'Efir yashirilgan',
    liveHint: 'Mini appda efir ekrani ko‘rsatiladimi. Tortishuv va g‘olibga ta’sir qilmaydi.',
    reminderSent: 'Eslatma yuborilgan',
    empty: 'Hali birorta tortishuv jadvalga qo‘yilmagan.',
    noWinner: '—',
  },
  reveal: {
    title: 'Efir konsoli',
    subtitle: 'Bosqichlarni tomoshabinlarga chiqarish.',
    prize: 'Sovrin',
    ticketCount: 'Ishtirokchi biletlar',
    videoLink: 'Video havolasi',
    scheduledAt: 'Efir vaqti',
    stepsCount: 'Bosqichlar',
    notCompleted: 'Bu tortishuv hali o‘tkazilmagan — avval uni o‘tkazing.',
    postponed: 'Bu efir qoldirilgan.',
    stepsHeading: 'E’lon qilingan bosqichlar',
    noSteps: 'Hali hech narsa e’lon qilinmagan.',
    revealTicketCount: 'Ishtirokchilar sonini e’lon qilish',
    revealShortlist: 'Bilet belgisi ochildi',
    revealWinner: 'G‘olibni e’lon qilish',
    progressiveHeading: 'G‘olib biletini harfma-harf ochish',
    progressiveHint:
      'Har bosishda server g‘olib biletining keyingi belgisini ochadi va qolgan nomzodlar sonini hisoblaydi.',
    progressiveWaiting: 'Birinchi belgi hali ochilmagan.',
    maskedTicket: 'Ochilayotgan bilet',
    characterProgress: 'Ochilgan belgilar',
    candidateCount: 'Qolgan nomzodlar',
    progressiveInProgress: 'Ochilmoqda',
    progressiveComplete: 'Kod to‘liq ochildi',
    revealNextCharacter: 'Keyingi belgini ochish',
    ticketCountFirst: 'Avval ishtirokchilar sonini e’lon qiling.',
    completeRevealFirst: 'Avval bilet kodini to‘liq oching.',
    confirmWinnerTitle: 'G‘olibni e’lon qilishni tasdiqlaysizmi?',
    confirmWinnerBody:
      'Bu qadamni qaytarib bo‘lmaydi: e’lon qilingan g‘olib barcha ekranlarda darhol ko‘rinadi.',
    confirmWinnerAction: 'Ha, g‘olibni e’lon qilaman',
    alreadyRevealed: 'E’lon qilingan',
    winnerRank: '{rank}-g‘olib',
    winnerAnnounced: 'E‘lon qilindi',
    winnerNext: 'Navbatda',
    winnerWaiting: 'Kutmoqda',
    winnerHeading: 'G‘olib',
    winnerTicket: 'Bilet',
    winnerUser: 'Foydalanuvchi',
    winnerTelegram: 'Telegram ID',
    revealing: 'Yuborilmoqda…',
    offsetNote:
      'Bosqich tomoshabinlarga sozlangan kechikish (offset) bilan yetib boradi — konsolda esa darhol ko‘rinadi.',
    overlayHeading: 'OBS overlay',
    generateOverlayAccess: 'OBS havolasini yaratish',
    generatingOverlayAccess: 'Havola yaratilmoqda…',
    overlayReady: 'OBS havolasi tayyor',
    copyOverlayUrl: 'Havolani nusxalash',
    overlayUrlCopied: 'Havola nusxalandi',
    openOverlay: 'Overlayni ochish',
    overlayAccessFailed: 'OBS havolasini yaratib bo‘lmadi.',
    overlayCopyFailed: 'Havolani nusxalab bo‘lmadi.',
    overlayLive: 'Overlay ulangan',
    overlayStale: 'Overlay javob bermayapti',
    overlayNeverSeen: 'Overlay hali ulanmagan',
    overlayStaleHint: 'OBS manbasi muzlab qolgan bo‘lishi mumkin — ekranda oxirgi kadr turadi.',
    overlaySecondsAgo: 'soniya oldin',
    overlayMinutesAgo: 'daqiqa oldin',

    announceHeading: 'G‘oliblarni e’lon qilish',
    announceHint:
      'Efir yakunlangach barcha foydalanuvchilarga Telegram orqali natija xabari yuboriladi. Xabar olishdan voz kechganlar va g‘oliblarning o‘zi ro‘yxatga kirmaydi.',
    announceAction: 'G‘oliblarni e’lon qilish',
    announcing: 'Navbatga qo‘yilmoqda…',
    announceRevealFirst: 'Avval barcha g‘oliblarni efirda e’lon qiling.',
    announceLiveDisabled: 'Efir mini appda yashirilgan — undan xabar yuborilmaydi.',
    // `alreadyRevealed` («E'lon qilingan») dan farq qilishi SHART: u bosqich efirga chiqqanini
    // bildiradi, bu esa xabar butun bazaga ketganini. Ikkalasi bir xil yozilganida operator
    // g'olib e'lon qilingan efirni "xabar ham ketgan" deb o'qishi mumkin edi.
    announceDone: 'Barchaga yuborildi',
    announceQueued: '{count} ta foydalanuvchi navbatga qo‘yildi.',
    announceFinishesAt: 'Oxirgi xabar taxminan {time} da yetib boradi.',
    confirmAnnounceTitle: 'Barcha foydalanuvchilarga xabar yuborilsinmi?',
    confirmAnnounceBody:
      'Bu qadamni qaytarib bo‘lmaydi: xabar butun bazaga ketadi va navbatga qo‘yilgandan keyin to‘xtatib bo‘lmaydi.',
    confirmAnnounceAction: 'Ha, e’lon qilaman',
  },
  overlay: {
    connecting: 'Efirga ulanmoqda…',
    unavailable: 'Efir holatini olib bo‘lmadi',
    missingAccess: 'OBS havolasi yaroqsiz',
    ticketCount: 'Tortishuvda qatnashmoqda',
    tickets: 'ta bilet',
    // Raqamdan keyin turadi: «bir yuz o‘n sakkiz kishi tomosha qilmoqda».
    viewers: 'kishi tomosha qilmoqda',
    // Chipning barqaror nomi — sanoq kartasidagidek, o‘zgaruvchan raqam e’lon qilinmaydi.
    viewersLabel: 'Efirni tomosha qilayotganlar',
    preShowEyebrow: 'Tez orada',
    // Sanoq kartasining barqaror nomi — o‘zgaruvchan raqamlar e’lon qilinmaydi.
    preShowLabel: 'Efir tez orada boshlanadi',
    preShowStarting: 'Efir boshlanmoqda…',
    revealHeading: 'G‘olib bileti ochilmoqda',
    // Mini App’dagi `revealCulminationTitle` bilan bir ma’noda: ikkalasi bir vaqtda efirda turadi.
    revealCulminationHeading: 'G‘olib bileti tasdiqlanmoqda',
    candidates: 'Qolgan nomzodlar',
    // Kulminatsiyada raqam hech narsa qo‘shmaydi — «bitta» so‘zning o‘zida.
    revealCulminationCandidates: 'Bitta bilet qoldi',
    progress: 'Bilet kodi ochilish jarayoni',
    winner: 'Bugungi g‘olib',
  },
  drawErrors: {
    alreadyCompleted: 'Bu tortishuv allaqachon o‘tkazilgan.',
    notCompleted: 'Avval tortishuvni o‘tkazing.',
    stepAlreadyRevealed: 'Bu bosqich allaqachon e’lon qilingan.',
    revealOutOfOrder: 'Bosqichlar tartibini saqlang: avval biletlar soni, keyin kod, so‘ng g‘olib.',
    shortlistComplete: 'G‘olib bileti kodi allaqachon to‘liq ochilgan.',
    revealStateStale:
      'Efir holati boshqa konsolda o‘zgardi. Yangilangan holatni tekshirib, qayta bosing.',
    noEligibleTickets: 'Bu davr uchun mos bilet yo‘q.',
    notFound: 'Tortishuv topilmadi.',
    prizeLabelRequired:
      'Bu efir jadvalga qo‘yilmagan. Avval «Jadvalga qo‘yish» orqali vaqt va sovrinni yozing.',
    rateLimited: 'Juda ko‘p urinish. Biroz kutib, qayta urinib ko‘ring.',
    // Ataylab umumiy: bu kod har qanday maydonga tegishli bo'lishi mumkin. Video havolasining
    // sharti maydonning o'z yorlig'ida yozilgan.
    validation: 'Kiritilgan ma’lumot noto‘g‘ri — maydonlarni tekshiring.',
    unknown: 'Xatolik yuz berdi. Qayta urinib ko‘ring.',
    network: 'Serverga ulanib bo‘lmadi',
  },
  moderation: {
    tabsLabel: 'Moderatsiya bo‘limlari',
    tabReceipts: 'Cheklar',
    tabPhotos: 'Rasmlar',
    tabMeals: 'Ovqatlar',
    tabFraud: 'Tekshiruv navbati',
    mealsHeading: 'Ovqat rasmlari',
    mealsSubtitle: 'Ovqat oqimi — o‘z kunlik chegarasi va o‘z to‘lovi bilan.',
    title: 'Moderatsiya',
    subtitle: 'Cheklar, rasm skanlari va tekshiruvdagi biletlar.',
    fraudSubtitle: 'Qaror uchun sabab majburiy — u audit jurnaliga yoziladi.',
    receiptsSubtitle: 'Holat qiymatlari bazadagi qiymatning o‘zi.',
    photosSubtitle: 'AI tanigan mahsulotlar va yakuniy holat.',
    filterReset: 'Filtrni tozalash',
    page: 'Sahifa',
    receiptsHeading: 'Cheklar',
    photosHeading: 'Rasm skanlari',
    fraudHeading: 'Tekshiruvdagi biletlar',
    filterStatus: 'Holat',
    filterAll: 'Hammasi',
    filterUser: 'Foydalanuvchi ID',
    filterFrom: 'Sanadan',
    filterTo: 'Sanagacha',
    apply: 'Filtrlash',
    columnUser: 'Foydalanuvchi',
    columnScannedAt: 'Skan vaqti',
    columnTotal: 'Summa',
    columnPoints: 'Ball',
    columnItems: 'Mahsulot',
    columnRecognised: 'AI topgan',
    columnVerifiedBy: 'Tasdiqlagan',
    columnError: 'Xato',
    columnTicket: 'Bilet',
    columnReceipt: 'Chek',
    columnMonth: 'Oy',
    columnAcquired: 'Olingan sana',
    columnActions: 'Amallar',
    revoked: 'Bekor qilingan',
    fraudEmpty: 'Tekshiruvni kutayotgan bilet yo‘q.',
    restore: 'Tiklash',
    revoke: 'Bekor qilish',
    reason: 'Sabab',
    reasonRequired: 'Sababni yozing',
    restored: 'Bilet tiklandi',
    revokedDone: 'Bilet bekor qilindi',
    // `{month}` — biletning ko'chirilgan oyi. Raqam bu yerda emas, javobdan keladi.
    compensated: 'Bu biletning oyi allaqachon o‘ynalgan edi — bilet {month} oyiga ko‘chirildi.',
  },
  dlq: {
    title: 'Xato navbat (DLQ)',
    subtitle: 'Bajarilmagan vazifalar va yetkazilmagan xabarlar.',
    queueHeading: 'Chek vazifalari',
    notificationsHeading: 'Yetkazilmagan xabarlar',
    unavailable: 'Navbatga ulanib bo‘lmadi — bu ro‘yxat to‘liq emas.',
    // `{total}` — serverdan kelgan son.
    total: 'Jami: {total}',
    empty: 'Navbatda xato vazifa yo‘q.',
    columnJob: 'Vazifa',
    columnReceipt: 'Chek',
    columnReason: 'Sabab',
    columnAttempts: 'Urinish',
    columnFailedAt: 'Vaqti',
    columnUser: 'Foydalanuvchi',
    columnFiscalKey: 'Fiskal kalit',
    columnType: 'Turi',
    columnStatus: 'Holat',
    columnDraw: 'Efir',
    filterDraw: 'Efir ID',
    notificationsEmpty: 'Yetkazilmagan xabar yo‘q.',
    failedReceiptsHeading: 'Skraperda to‘xtagan cheklar',
    retryButton: 'Qayta urinish (Retry)',
    retryAllButton: 'Barchasini qayta urinish',
    retrying: 'Qayta navbatga qo‘yilmoqda…',
    retrySuccess: '{count} ta chek qayta navbatga qo‘yildi',
  },
  users: {
    title: 'Foydalanuvchilar',
    subtitle: 'Ro‘yxat va kartochka. Kartochka ochilishi audit jurnaliga yoziladi.',
    listHeading: 'Ro‘yxat',
    listHint:
      'Ro‘yxat ro‘yxatdan o‘tgan vaqt bo‘yicha, yangisidan boshlab chiqadi. Qidiruv uni toraytiradi.',
    listEmpty: 'Hali birorta foydalanuvchi yo‘q.',
    cardHeading: 'Kartochka',
    closeCard: 'Kartochkani yopish',
    balanceOk: 'Ustun va ledger mos',
    emptySelection: 'Kartochkani ochish uchun qidiruv natijasidan foydalanuvchini tanlang.',
    statTickets: 'Biletlar',
    statReceipts: 'Cheklar',
    statPhotos: 'Rasm skanlari',
    statAll: 'Jami foydalanuvchi',
    statToday: 'Bugun qo‘shilgan',
    statWeek: 'Shu haftada',
    statBlocked: 'Bloklangan',
    searchHeading: 'Qidiruv',
    searchLabel: 'Telefon, Telegram ID, username, ism yoki ichki ID',
    search: 'Qidirish',
    empty: 'Hech kim topilmadi.',
    columnUser: 'Foydalanuvchi',
    columnTelegram: 'Telegram ID',
    columnPhone: 'Telefon',
    /* Botda `request_contact` bosilmagan hisob — raqam bizda YO'Q, xato emas. */
    phoneMissing: 'Ulashmagan',
    columnBalance: 'Balans',
    columnCreatedAt: 'Ro‘yxatdan o‘tgan',
    open: 'Ochish',
    balanceHeading: 'Balans',
    balanceColumn: 'Ustundagi qiymat',
    balanceLedger: 'Ledger yig‘indisi',
    balanceMismatch: 'Ustun va ledger mos emas!',
    ticketsHeading: 'Biletlar',
    receiptsHeading: 'Cheklar',
    photosHeading: 'Rasm skanlari',
    ledgerHeading: 'Ball tarixi',
    blocked: 'Bloklangan',
  },
  exportData: {
    title: 'Data eksport',
    subtitle: 'Cheklar va mahsulotlar bo‘yicha CSV.',
    heading: 'Cheklar va mahsulotlar (CSV)',
    // `{days}` — `ADMIN_EXPORT_MAX_RANGE_DAYS`. Raqamlar faqat `constants.ts` da yashaydi.
    rangeHint:
      'Oraliq majburiy va eng ko‘pi bilan {days} kun bo‘lishi mumkin. Eksport audit jurnaliga yoziladi.',
    from: 'Sanadan',
    to: 'Sanagacha',
    download: 'Yuklab olish',
    downloading: 'Tayyorlanmoqda…',
    done: 'Fayl yuklandi',
    identityNote: 'Faylda Telegram identifikatori va ism bo‘lmaydi — faqat ichki ID.',
  },
  accounts: {
    title: 'Admin hisoblari',
    subtitle: 'Mavjud hisoblarni yoqish va o‘chirish.',
    hint: 'Yangi hisob va parol faqat serverdagi skript orqali yaratiladi.',
    columnEmail: 'Email',
    columnRole: 'Rol',
    columnState: 'Holat',
    columnLastLogin: 'Oxirgi kirish',
    columnActions: 'Amallar',
    roleAdmin: 'Admin',
    roleOperator: 'Operator',
    active: 'Faol',
    inactive: 'O‘chirilgan',
    deactivate: 'O‘chirish',
    activate: 'Yoqish',
    reason: 'Sabab',
    self: 'Bu — sizning hisobingiz',
    never: '—',
  },
  rewards: {
    title: 'Ball-katalog',
    subtitle: 'Ballarga almashtiriladigan sovg‘alar ro‘yxati.',
    hint: 'Ro‘yxat tartib (pozitsiya) bo‘yicha, o‘sish tartibida chiqadi.',
    createHeading: 'Yangi band qo‘shish',
    listHeading: 'Mavjud bandlar',
    columnImage: 'Rasm',
    columnName: 'Nomi',
    columnPointsCost: 'Ball narxi',
    columnPosition: 'Tartib',
    columnState: 'Holat',
    columnActions: 'Amallar',
    name: 'Nomi',
    pointsCost: 'Ball narxi',
    position: 'Tartib',
    positionHint: 'Kichik son avval chiqadi. Bo‘sh qoldirilsa, ro‘yxat oxiriga qo‘shiladi.',
    state: 'Holat',
    active: 'Faol',
    inactive: 'Nofaol',
    create: 'Qo‘shish',
    creating: 'Qo‘shilmoqda…',
    edit: 'Tahrirlash',
    save: 'Saqlash',
    saving: 'Saqlanmoqda…',
    cancel: 'Bekor qilish',
    delete: 'O‘chirish',
    deleteConfirm: 'Rostdan o‘chirilsinmi?',
    deleteConfirmYes: 'Ha, o‘chirish',
    deleting: 'O‘chirilmoqda…',
    empty: 'Hali birorta band qo‘shilmagan.',
    image: 'Rasm',
  },
  /** Sovg'a buyurtmalari navbati (P8.1). */
  redemptions: {
    title: 'Sovg‘a buyurtmalari',
    subtitle: 'Ball evaziga olingan sovg‘alar: kimga nima topshirilishi kerak.',
    all: 'Hammasi',
    empty: 'Bu filtrga mos buyurtma yo‘q.',

    statPending: 'Kutilmoqda',
    statDelivered: 'Topshirilgan',
    statCancelled: 'Bekor qilingan',
    statPendingPoints: 'Ushlab turilgan ball',
    statPendingPointsHint: 'Topshirilmagan buyurtmalar uchun allaqachon yechilgan ball.',

    filterStatus: 'Holat',
    filterQuery: 'Qidiruv',
    filterQueryHint: 'Telegram id, ism, telefon yoki sovg‘a nomi.',
    filterFrom: 'Sanadan',
    filterTo: 'Sanagacha',
    filterReset: 'Filtrni tozalash',

    columnUser: 'Foydalanuvchi',
    columnItem: 'Sovg‘a',
    columnPoints: 'Ball',
    columnStatus: 'Holat',
    columnDecision: 'Qaror',
    columnActions: 'Amallar',

    statusPending: 'Kutilmoqda',
    statusDelivered: 'Topshirildi',
    statusCancelled: 'Bekor qilindi',
    noDecision: 'Hali qaror qilinmagan',

    deliver: 'Topshirildi',
    deliverTitle: 'Sovg‘a topshirildi deb belgilash',
    deliverHint: 'Ballga tegmaydi — u almashtirish paytida allaqachon yechilgan.',
    deliverSubmit: 'Belgilash',
    note: 'Izoh',
    noteHint: 'Ixtiyoriy. Faqat admin panelda ko‘rinadi.',

    cancel: 'Bekor qilish',
    cancelTitle: 'Buyurtmani bekor qilish va ballni qaytarish',
    cancelHint: 'Foydalanuvchiga qaytariladigan ball',
    cancelSubmit: 'Bekor qilish va qaytarish',
    reason: 'Sabab',
    reasonHint: 'Majburiy — audit jurnaliga tushadi. Foydalanuvchiga ko‘rsatilmaydi.',
  },
  uploads: {
    thumbnailAlt: 'Rasm',
    noImage: 'Rasm yo‘q',
    choose: 'Rasm tanlash',
    uploading: 'Yuklanmoqda…',
    tooLarge: 'Fayl hajmi ruxsat etilgan chegaradan katta',
    typeInvalid: 'Faqat JPEG, PNG yoki WEBP formatlari qabul qilinadi',
    failed: 'Rasmni yuklab bo‘lmadi',
  },
  banners: {
    title: 'Bannerlar',
    subtitle: 'Bosh ekrandagi banner-slayder boshqaruvi.',
    hint: 'Ro‘yxat tartib (pozitsiya) bo‘yicha, o‘sish tartibida chiqadi.',
    createHeading: 'Yangi banner qo‘shish',
    listHeading: 'Mavjud bannerlar',
    columnImage: 'Rasm',
    columnLink: 'Havola',
    columnPosition: 'Tartib',
    columnState: 'Holat',
    columnActions: 'Amallar',
    image: 'Rasm',
    imageRequired: 'Rasm yuklang',
    link: 'Havola',
    linkHint: 'Ilova ichida: rewards, luck, history. Tashqi: https://...',
    linkKind: 'Havola turi',
    linkKindInternal: 'Ilova ichidagi ekran',
    linkKindExternal: 'Tashqi havola (yangi oynada)',
    linkExternalInvalid: 'Tashqi havola http:// yoki https:// bilan boshlanishi kerak',
    columnLinkKind: 'Turi',
    position: 'Tartib',
    positionHint: 'Kichik son avval chiqadi. Bo‘sh qoldirilsa, ro‘yxat oxiriga qo‘shiladi.',
    state: 'Holat',
    active: 'Faol',
    inactive: 'Nofaol',
    create: 'Qo‘shish',
    creating: 'Qo‘shilmoqda…',
    edit: 'Tahrirlash',
    save: 'Saqlash',
    saving: 'Saqlanmoqda…',
    cancel: 'Bekor qilish',
    delete: 'O‘chirish',
    deleteConfirm: 'Rostdan o‘chirilsinmi?',
    deleteConfirmYes: 'Ha, o‘chirish',
    deleting: 'O‘chirilmoqda…',
    empty: 'Hali birorta banner qo‘shilmagan.',
  },
  degradedMode: {
    bannerTitle: 'Tizim Cheklangan Rejimda (Degraded Mode)',
    bannerDescription:
      'Soliq ofd skraperida uzilish yuz bergan yoki rejim qo‘lda yoqilgan. Foydalanuvchilar ballari va cheklari xavfsiz holda saqlanmoqda (revocation to‘xtatilgan).',
    reasonPrefix: 'Sabab: ',
    automatic: 'Avtomatik aniqlangan',
    manual: 'Admin tomonidan yoqilgan',
    resetButton: 'Normal rejimga qaytarish (Reset)',
    resetting: 'Tiklanmoqda…',
    enableButton: 'Cheklangan rejimni yoqish',
    enabling: 'Yoqilmoqda…',
    successDisable: 'Tizim normal ish rejimiga qaytarildi',
    successEnable: 'Cheklangan rejim faollashtirildi',
  },
  /**
   * Bot xabarlari — shablonlar tahriri.
   *
   * Matnlar RAQAMSIZ va NAMUNASIZ: shablonning o'zi konfiguratsiya, ya'ni bu yerdagi so'zlar
   * faqat interfeysni tushuntiradi, xabarning mazmunini emas.
   */
  notificationTemplates: {
    title: 'Bot xabarlari',
    subtitle: 'Telegram botga ketadigan xabarlar matni va tugmalari.',
    hint:
      'Tahrirlangan matn darhol kuchga kiradi — restart kerak emas. Tegilmagan shablon ' +
      'fayl yoki koddagi standart matnni ko\u2018rsatadi.',
    listHeading: 'Shablonlar',
    columnKey: 'Kalit',
    columnState: 'Holat',
    columnUpdated: 'Oxirgi tahrir',
    overridden: 'Tahrirlangan',
    default: 'Standart',
    editHeading: 'Xabar matni',
    bodyLabel: 'Matn',
    buttonHeading: 'Tugma',
    buttonHint:
      'Yozuv va manzil BIRGA to\u2018ldiriladi yoki ikkalasi ham bo\u2018sh qoldiriladi. ' +
      'Manzilda ham {\u2026} ishlaydi \u2014 masalan {miniAppUrl}/omad/{drawId} tugmani ' +
      'aynan o\u2018sha efirga olib boradi.',
    buttonLabelLabel: 'Tugma yozuvi',
    buttonUrlLabel: 'Tugma manzili',
    previewHeading: 'Oldindan ko\u2018rish',
    previewHint: 'Namunaviy qiymatlar bilan, serverda render qilinadi.',
    previewButton: 'Yangilash',
    previewing: 'Render qilinmoqda\u2026',
    previewEmpty: 'Ko\u2018rish uchun \u00abYangilash\u00bb ni bosing.',
    save: 'Saqlash',
    saving: 'Saqlanmoqda\u2026',
    saved: 'Shablon saqlandi',
    reset: 'Standartga qaytarish',
    resetting: 'Qaytarilmoqda\u2026',
    resetDone: 'Standart matn tiklandi',
    resetConfirm: 'Tahrir o\u2018chiriladi va fayl/koddagi matn qaytadi. Davom etamizmi?',
    toolbar: 'Matn formati',
    bold: 'Qalin',
    italic: 'Kursiv',
    underline: 'Tagi chizilgan',
    strike: 'Ustidan chizilgan',
    code: 'Kod',
    link: 'Havola',
    placeholders: 'Qo\u2018yish:',
    empty: 'Shablon topilmadi.',
    selectHint: 'Tahrirlash uchun ro\u2018yxatdan shablonni tanlang.',
    testHeading: 'Botga yuborib ko\u2018rish',
    testHint:
      'Ekrandagi matn o\u2018sha holicha bitta chatga yuboriladi \u2014 saqlash shart emas. ' +
      'Telegram chat id ni kiriting (odatda o\u2018z hisobingiz).',
    testChatId: 'Telegram chat id',
    testSend: 'Sinov xabarini yuborish',
    testSending: 'Yuborilmoqda\u2026',
    testSent: 'Yuborildi \u2014 Telegramni tekshiring.',
    testNoButton: 'Yuborildi, LEKIN tugmasiz: manzil to\u2018ldirilmagan yoki sozlanmagan.',
    testFailed: 'Yuborilmadi: {error}',
  },
  /**
   * Xabarlar navbati — monitoring.
   *
   * «Qotgan» so'zi ataylab: «xato» emas. Muddati o'tib ketgan `queued` qator ham shu yerga
   * kiradi va uning statusi hech qanday xato ko'rsatmaydi.
   */
  notifications: {
    title: 'Xabarlar navbati',
    subtitle: 'Botga ketadigan xabarlarning holati va yetkazilmaganlari.',
    statQueued: 'Navbatda',
    statSent: 'Yuborilgan',
    statFailed: 'Xato bilan tugagan',
    statStuck: 'Qotib qolgan',
    statRetryable: 'Qayta urinsa bo\u2018ladi',
    oldestStuck: 'Eng eskisi',
    minutesAgo: 'daqiqa oldin',
    filterStatus: 'Holat',
    filterType: 'Turi',
    filterStuck: 'Faqat qotganlari',
    filterQuery: 'Foydalanuvchi',
    filterQueryHint: 'Telegram id, ism yoki telefon raqami',
    filterFrom: 'Sanadan',
    filterTo: 'Sanagacha',
    filterReset: 'Filtrni tozalash',
    all: 'Hammasi',
    columnUser: 'Foydalanuvchi',
    columnType: 'Turi',
    columnStatus: 'Holat',
    columnAttempts: 'Urinish',
    columnScheduled: 'Rejalashtirilgan',
    columnSent: 'Yuborilgan',
    columnCreated: 'Yaratilgan',
    columnReason: 'Sabab',
    columnAction: 'Amal',
    statusQueued: 'Navbatda',
    statusSent: 'Yuborilgan',
    statusFailed: 'Xato',
    stuckBadge: 'Qotgan',
    retry: 'Qayta urinish',
    retrying: 'Yuborilmoqda\u2026',
    retryAll: 'Qotganlarning hammasini qayta urinish',
    retryAllConfirm:
      'Filtrga mos QOTGAN xabarlarning hammasi qayta navbatga qo\u2018yiladi. Davom etamizmi?',
    retryDone: 'Qayta navbatga qo\u2018yildi',
    retrySkipped: 'chetda qoldi',
    noReason: 'Sabab yozilmagan',
    blockedUserBlocked: 'Foydalanuvchi bloklangan (moderator)',
    blockedBotBlocked: 'Foydalanuvchi botni bloklagan',
    blockedChatNotFound: 'Telegram chati topilmadi',
    blockedAlreadySent: 'Allaqachon yuborilgan',
    blockedNotStuck: 'Hali navbatda \u2014 qotgani yo\u2018q',
    empty: 'Bu filtrga mos xabar yo\u2018q.',
    typeReceiptRevoked: 'Chek bekor qilindi',
    typeReceiptPoints: 'Chek uchun ball',
    typeDrawWin: 'Yutuq xabari',
    typeDrawReminder: 'Efir eslatmasi',
    typeDrawResult: 'G\u2018oliblar e\u2019loni',
    typeReferralBonus: 'Referal bonusi',
    typeRewardDelivered: 'Sovg‘a topshirildi',
    typeRewardCancelled: 'Sovg‘a bekor qilindi',
  },
} as const;

export type Strings = typeof strings;
